exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\r\n\r\n\r\n.meal-list{\r\n  list-style: none;\r\n  padding-left: 0px;\r\n}\r\n\r\n.meal-list li  > div{\r\n  text-align: left;\r\n  border: 1px #ccc solid;\r\n  padding-bottom: 5px;\r\n  padding-top: 5px;\r\n  word-wrap: break-word;\r\n}\r\n\r\n.meal-list-head{\r\n  margin-bottom:0px;\r\n}\r\n\r\n.meal-list-head li > div{\r\n    padding-bottom: 5px;\r\n    padding-top: 5px;\r\n    font-weight: 600;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/duetz.repos/angular4/~/css-loader?{"sourceMap":false,"importLoaders":1}!C:/wamp64/www/duetz.repos/angular4/~/postcss-loader?{"ident":"postcss"}!C:/wamp64/www/duetz.repos/angular4/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = 2